import { action } from 'typesafe-actions';
import {
  BpeTypes,
  BpeConfigInterface,
} from './types';

// Get Bpe config
export const getBpeConfigRequest = (payload: object) =>
  action(BpeTypes.GET_BPE_CONFIG_REQUEST, payload);
export const getBpeConfigSuccess = (payload: {
  bpeConfigData: BpeConfigInterface;
}) => action(BpeTypes.GET_BPE_CONFIG_SUCCESS, payload);
export const getBpeConfigFailure = () =>
  action(BpeTypes.GET_BPE_CONFIG_FAILURE);

// Update Bpe config
export const updateBpeConfigRequest = (payload: object) =>
  action(BpeTypes.UPDATE_BPE_CONFIG_REQUEST, payload);
export const updateBpeConfigSuccess = (payload: {
  bpeConfigData: BpeConfigInterface;
}) => action(BpeTypes.UPDATE_BPE_CONFIG_SUCCESS, payload);
export const updateBpeConfigFailure = () =>
  action(BpeTypes.UPDATE_BPE_CONFIG_FAILURE);

